import "./Card.css";
const Card = (props) => {
  const cssClassName = "card ";
  return <div className={cssClassName}>{props.children}</div>;
};

export default Card;
